var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotAllow',[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../assets/images/not-allow.png")}}),_c('h2',[_vm._v("无权访问")]),_c('p',[_vm._v("如您需要访问该系统，请联系系统管理员")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.logout}},[_vm._v("退出系统")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }